import { createMatchState } from "./rules";
import type { DifficultyId, MatchState } from "./types";

export class GameState {
  match: MatchState;
  frozen = false;
  simTimeMs = 0;
  shake = 0;
  dayTime = 0;

  constructor(difficulty: DifficultyId) {
    this.match = createMatchState(difficulty);
  }

  reset(difficulty: DifficultyId): void {
    this.match = createMatchState(difficulty);
    this.frozen = false;
    this.simTimeMs = 0;
    this.shake = 0;
  }
}
